import { mainAxios } from "@/mainAxios.js";
import { getAgenteAccessToken } from "../tokens.service";

export const getCategorias = async (tipo, especial, alianza, productoId) => {
  const config = {
    headers: {
      Authorization: "Bearer " + getAgenteAccessToken(),
    },
    params: {
      tipo, 
      especial,
      alianza,
      productoId
    },
  };

  const serverResponse = await mainAxios.get(
    "/v1/club-beneficios/categorias",
    config
  );
  return serverResponse.data.data;
};


export const getProveedor = async () => {
  const config = {
    headers: {
      Authorization: "Bearer " + getAgenteAccessToken(),
    },
  };

  const serverResponse = await mainAxios.get(
    "/v1/club-beneficios/proveedores",
    config
  );
  return serverResponse.data.data;
};

export const getTipos = async () => {
  const config = {
    headers: {
      Authorization: "Bearer " + getAgenteAccessToken(),
    },
  };

  const serverResponse = await mainAxios.get(
    "/v1/club-beneficios/tipos",
    config
  );
  return serverResponse.data;
};

export const getMarcas = async () => {
  const config = {
    headers: {
      Authorization: "Bearer " + getAgenteAccessToken(),
    },
  };

  const serverResponse = await mainAxios.get(
    "/v1/club-beneficios/marcas",
    config
  );
  return serverResponse.data.data;
};

export const getBeneficiosByFilters = async(request) => {
  const config = {
    headers: {
      Authorization: "Bearer " + getAgenteAccessToken(),
    },
  };

  const serverResponse = await mainAxios.post(
    "/v1/club-beneficios/filters",
    request,
    config
  );
  return serverResponse.data;
};
